import React from 'react';
import styles from './index.module.scss';

const ViewImageModal = ({ source, toggleModal, originalAspect }) => {
  return (
    <form className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <img src={source} className={`${originalAspect ? styles['original'] : styles['image']}`} />
      </div>
    </form>
  );
};

export default ViewImageModal;